import get from 'lodash-es/get'

const ignoredErrorsRegexList = [
  // Seems to be chrome bug, happening only on iphone or ipad - https://bugs.chromium.org/p/chromium/issues/detail?id=590375
  /__gCrWeb\.autofill\.extractForms/,

  // https://github.com/getsentry/raven-js/issues/756
  /null is not an object \(evaluating 'elt.parentNode'\)/,

  // And this is the kind of crap that makes GTM a horrible idea. Who know's where this came from? it's not our code :/
  /SecurityError \(DOM Exception 18\): Blocked a frame with origin/,

  // ios safari in private browsing mode causes a storm of errors (many/most of which trace back to the history package we have no control over)
  /QuotaExceededError \(DOM Exception 22\)/,

  // Appears to be malware
  // Stacktrace originates from https://pstatic.bestpriceninja.com/nwp/v0_0_1143/release/Shared/App/SharedApp.js
  /t.exec\(\.\.\.\) is null/,

  // happens when the user enters and leaves a page with braintree hosted fields before the bt js loads
  /FormNapper requires an HTMLFormElement/
]

export const isUnSupportedBrowser = userAgent => {
  const ie9AndBelowRegex = new RegExp('MSIE [1-9][^0-9]')
  return ie9AndBelowRegex.test(userAgent)
}

export default (isUncaught, args, payload) => {
  if (
    typeof window !== 'undefined' &&
    window.navigator.userAgent &&
    isUnSupportedBrowser(window.navigator.userAgent)
  ) {
    return true
  }

  try {
    if (isUncaught) {
      const errorDescription = get(payload, 'body.trace.exception.description')
      const errorMessage = get(payload, 'body.trace.exception.message')
      return ignoredErrorsRegexList.some(
        regex => regex.test(errorDescription) || regex.test(errorMessage)
      )
    }
  } catch (e) {
    // noop
  }

  return false
}
